<template>
  <label class="section-box-label"><slot /></label>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.section-box-label {
  font-size: 12px;
  font-weight: bold;
}
</style>